import { render, staticRenderFns } from "./seurantajakso-container.vue?vue&type=template&id=3629eee5&scoped=true&"
import script from "./seurantajakso-container.vue?vue&type=script&lang=ts&"
export * from "./seurantajakso-container.vue?vue&type=script&lang=ts&"
import style0 from "./seurantajakso-container.vue?vue&type=style&index=0&id=3629eee5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3629eee5",
  null
  
)

export default component.exports